import React from 'react';
import { memo } from 'common/hocs/memo';
import { CardMedia, MediaCard, MediaCardContent } from '../../media-card';
import { Typography } from '../../typography';
import {
  cardMediaStyle,
  cardTitleStyle,
  cardDescriptionStyle,
  mediaCardContentStyle,
} from './card-a-styles';

type TProps = {
  imageAlt: string;
  imageSrc: string;
  title: string;
  description?: string;
};

/**
 * Вью секции "Другие услуги"
 */
export const CardA = memo(
  ({ imageAlt, imageSrc, title, description }: TProps) => {
    return (
      <MediaCard>
        <CardMedia
          alt={imageAlt}
          className={cardMediaStyle}
          loading="lazy"
          src={imageSrc}
        />
        <MediaCardContent className={mediaCardContentStyle}>
          <Typography className={cardTitleStyle} variant="h3">
            {title}
          </Typography>
          {description && (
            <Typography className={cardDescriptionStyle} size="body_short" variant="m">
              {description}
            </Typography>
          )}
        </MediaCardContent>
      </MediaCard>
    );
  }
);
